<div
  [class]="customAppCssClass"
  [sgTooltip]="ctrl.isExpanded ? null : (mi.label | translate)"
  tooltipArrow="none"
  tooltipPosition="right"
  tooltipClass="sg-side-bar-tooltip"
  [class.is-floating-side-bar]="ctrl.isFloatingSideBar"
  class="sg-flex-row nav-menu-item-wrapper">
  @if (mi.icon) {
    <mat-icon class="navmenu-icon">{{ mi.icon }}</mat-icon>
  }
  @if (ctrl.isExpanded) {
    <span
      [@flyInOut]="'in'"
      (@flyInOut.start)="ctrl.menuItemAnimationStart()"
      (@flyInOut.done)="ctrl.menuItemAnimationEnd()"
      data-test="menuItemLabel"
      class="sg-flex-auto nav-menu-item-label">
      <span>{{ mi.label | translate }}</span>
    </span>
  }
  @if (!ctrl.isExpanded && mi.parent) {
    <span class="sg-flex-auto nav-menu-item-label">
      <span>{{ mi.label | translate }}</span>
    </span>
  }
  <ng-content></ng-content>
  @if (badge && ctrl.isExpanded) {
    <sg-counter-badge
      [value]="numberBadge"
      variant="counter"
      color="on-color"
      [class.sg-main-menu-badge]="!isGroup"
      data-test="counterLabel"></sg-counter-badge>
  }
  @if (isGroup && ctrl.isExpanded) {
    <div class="caret-container">
      <mat-icon class="caret" [class.opened]="expanded">keyboard_arrow_down</mat-icon>
    </div>
  }
  @if (badge && !ctrl.isExpanded && ctrl.isFloatingSideBar) {
    <sg-counter-badge class="closed-badge" [value]="numberBadge" variant="dot" color="on-color"></sg-counter-badge>
  }
</div>
